module.exports = __webpack_public_path__ + "static/media/icon_relationship.079ff87f.svg";